/**
 * Thema „Phasen & Fälligkeitsdatum" (PV-037, A7): die eingerichteten Phasen aus GET /v1/phases in
 * ihrer Reihenfolge, je Phase die Bedeutung des Datums. Umbenennen im Admin wirkt ohne Codeänderung.
 */
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../../lib/api.js';
import { HilfeHinweis } from './hilfe-hinweis.js';
import type { HilfeThemaProps } from './hilfe-typen.js';

export function ThemaPhasen({ kompakt }: HilfeThemaProps) {
  const { t } = useTranslation();
  // Gleicher Schlüssel wie Handover/KFML-Worklist — eine Abfrage, ein Cache.
  const query = useQuery({ queryKey: ['v2-phases'], queryFn: () => api.listPhases() });
  if (query.isError) return <HilfeHinweis fehler>{t('hilfe.seite.fehler')}</HilfeHinweis>;
  if (query.isLoading) return <HilfeHinweis>{t('hilfe.seite.laedt')}</HilfeHinweis>;

  const phasen = [...(query.data?.items ?? [])].sort((a, b) => a.order - b.order);
  return (
    <div
      className={`space-y-2 ${kompakt ? 'text-xs' : 'text-sm'}`}
      style={{ color: 'var(--ink-2)' }}
    >
      <p>{t('hilfe.phasen.einleitung')}</p>
      {phasen.length === 0 ? (
        <p>{t('hilfe.phasen.leer')}</p>
      ) : (
        <ol className="list-decimal space-y-1.5 pl-5">
          {phasen.map((p) => (
            <li key={p.phase_id}>
              <span className="font-medium" style={{ color: 'var(--ink)' }}>
                {p.name}
              </span>
              {' — '}
              <span>{t(`hilfe.phasen.bedeutung.${p.due_meaning ?? 'none'}`)}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
